/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NipsPainScaleAliases {
  ALERT_STATE_RG = 'alert-state-rg',
  ALERT_STATE_TEXT = 'alert-state-text',
  ARMS_RG = 'arms-rg',
  ARMS_TEXT = 'arms-text',
  BREATHING_RG = 'breathing-rg',
  BREATHING_TEXT = 'breathing-text',
  CRY_RG = 'cry-rg',
  CRY_TEXT = 'cry-text',
  FACIAL_EXPRESSION_RG = 'facial-expression-rg',
  FACIAL_EXPRESSION_TEXT = 'facial-expression-text',
  LEGS_RG = 'legs-rg',
  LEGS_TEXT = 'legs-text',
  MODAL_PAIN_SCALE_REFERENCE = 'modal-pain-scale-reference',
  NIPS_ALERT_STATE_FIELD = 'nips-alert-state-field',
  NIPS_ALERT_STATE_SCALE_FORM = 'nips-alert-state-scale-form',
  NIPS_ARMS_FIELD = 'nips-arms-field',
  NIPS_ARMS_SCALE_FORM = 'nips-arms-scale-form',
  NIPS_BREATHING_FIELD = 'nips-breathing-field',
  NIPS_BREATHING_SCALE_FORM = 'nips-breathing-scale-form',
  NIPS_CRY_FIELD = 'nips-cry-field',
  NIPS_CRY_SCALE_FORM = 'nips-cry-scale-form',
  NIPS_FACIAL_EXPRESSION_FIELD = 'nips-facial-expression-field',
  NIPS_LEGS_FIELD = 'nips-legs-field',
  NIPS_LEGS_SCALE_FORM = 'nips-legs-scale-form',
  NIPS_PAIN_SCALE_LAYOUT = 'nips-pain-scale-layout',
  NIPS_REFERENCE_LINK = 'nips-reference-link',
  NIPS_REFERENCE_LINK_PANEL = 'nips-reference-link-panel',
  NIPS_REFERENCE_PANEL = 'nips-reference-panel',
  NIPS_SCALE_FORM = 'nips-scale-form',
  PAIN_SCALE_CONTENT_PANEL = 'pain-scale-content-panel',
  PAIN_SCALE_CONTEXTUAL_BAR = 'pain-scale-contextual-bar',
  TEXT_NIPS_PAIN_SCALE_REFERENCE = 'text-nips-pain-scale-reference',
}
export { NipsPainScaleAliases };
